import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.ime
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.navigation.NavDestination
import androidx.navigation.NavHostController
import com.hyperether.goodjob.CommonModule
import com.hyperether.goodjob.navigation.Container
import com.hyperether.goodjob.navigation.RouteScreen
import com.hyperether.goodjob.navigation.Splash
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.LocalScaleFactor
import com.hyperether.goodjob.util.Logger
import com.hyperether.goodjob.util.getPlatformScale
import com.mmk.kmpnotifier.notification.NotifierManager
import org.hyperether.auth.apple.AppleSignInConfig
import org.hyperether.auth.apple.AppleSignInConfigHolder
import org.hyperether.auth.google.GoogleSignInConfig
import org.hyperether.auth.google.GoogleSignInConfigHolder
import org.hyperether.auth.microsoft.MicrosoftSignInConfig
import org.hyperether.auth.microsoft.MicrosoftSignInConfigHolder
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
@Preview
fun App(
    navController: NavHostController,
    commonModule: CommonModule,
    onChoosePlanClick: (Double, String) -> Unit,
    onLogout: () -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit,
    onOpenPdf: (String) -> Unit,
    currentRoute: RouteScreen = Splash,
    onDestinationChanged: (NavDestination) -> Unit,
) {
//    SelectionContainer {
    LaunchedEffect(Unit) {
        GoogleSignInConfigHolder.configure(
            config = GoogleSignInConfig(
                webClientId = "571701800821-58vrrs26blikc7s1gd1dgbnu5pid5oue.apps.googleusercontent.com",
                iosClientId = "571701800821-rk4e4nb54lvjjt7qru7kjttd7nqapp2l.apps.googleusercontent.com",
//                    redirectUri = "https://goodjob.hyperether.com/google-callback",// only for web
                redirectUri = "https://dev.goodjob.hyperether.com/google-callback",// only for web
//                redirectUri = "http://localhost:8089/google-callback",// only for web
            )
        )

        AppleSignInConfigHolder.configure(
            config = AppleSignInConfig(
                iosServiceId = "ch.mycomp.goodjob.authclient",
//                    redirectUri = "https://goodjob.hyperether.com/apple-callback"// only for web & android
                redirectUri = "https://dev.goodjob.hyperether.com/apple-callback"// only for web & android
            )
        )

        MicrosoftSignInConfigHolder.configure(
            config = MicrosoftSignInConfig(
                clientId = "836d8831-2997-4e09-95c1-08b4718d8916",
                redirectUri = "https://goodjob.hyperether.com"
            )
        )
    }
    LaunchedEffect(true) {
        NotifierManager.addListener(object : NotifierManager.Listener {
            override fun onNewToken(token: String) {
                Logger.d("FCM", "onNewToken: $token")
                commonModule.repository.updateFCMPushToken(token)
            }
        })
    }

    MaterialTheme {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .windowInsetsPadding(WindowInsets.ime)
        ) {
            val scale = getPlatformScale()

            CompositionLocalProvider(LocalScaleFactor provides scale) {
                Container(
                    navController,
                    commonModule,
                    onChoosePlanClick,
                    onLogout,
                    onUploadDocumentClick,
                    onOpenPdf,
                    currentRoute,
                    onDestinationChanged = { destination ->
                        onDestinationChanged(destination)
                    }
                )
            }
        }
    }
}
//}